/**
 * Line item types for tuition calculations
 */
export var TuitionCalculationLineItemType;
(function (TuitionCalculationLineItemType) {
    // Tuition & Mandatory Fees section
    TuitionCalculationLineItemType["TUITION_COST"] = "tuition_cost";
    TuitionCalculationLineItemType["MANDATORY_FEE"] = "mandatory_fee";
    // Exclusions/Non-reimbursable section
    TuitionCalculationLineItemType["NON_REIMBURSABLE_FEE"] = "non_reimbursable_fee";
    // Credits for Tuition section
    TuitionCalculationLineItemType["CREDIT_TUITION"] = "credit_tuition";
    // Scholarships & Grants section
    TuitionCalculationLineItemType["SCHOLARSHIP_GRANT"] = "scholarship_grant";
    // Room & Board section
    TuitionCalculationLineItemType["ROOM_AND_BOARD"] = "room_and_board";
    // Credits for Housing section
    TuitionCalculationLineItemType["CREDIT_HOUSING"] = "credit_housing";
})(TuitionCalculationLineItemType || (TuitionCalculationLineItemType = {}));
